import { create } from 'zustand';

interface IBottomBarStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useBottomBarStore = create<IBottomBarStore>((set) => ({
  isOpen: false,
  open: () => set(() => ({ isOpen: true })),
  close: () => set(() => ({ isOpen: false })),
}));
